import React from "react";
import textConfig from "../utils/text";

export default function frame22(props: any){
	let { Svg, svgProps, children, viewBox, frameBody } = props;
	let { path, text_1 } = props, [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
	
	
	return <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 2209 1070">
		<defs>
			<clipPath id="clip0_241_1988">
				<rect width="2208.01" height="1069.57" fill="white"/>
			</clipPath>
			<clipPath id="myClip">
				<rect width="1000" height="1000" rx={20} fill={'none'}/>
			</clipPath>
		</defs>
		<g transform={"translate(1173 35)"}>
			<g clipPath="url(#myClip)">{children}</g>
		</g>
		<g clipPath="url(#clip0_241_1988)">
			<path
				d="M2160.01 0C2186.52 0 2208.01 21.2831 2208.01 47.5361V1022.03C2208.01 1048.28 2186.52 1069.57 2160.01 1069.57H1176.01C1149.5 1069.57 1128.01 1048.28 1128.01 1022.03V748.697C1128.2 747.088 1128.02 745.456 1127.48 743.927C1126.95 742.397 1126.07 741.01 1124.92 739.871C1123.76 738.725 1122.35 737.855 1120.81 737.325C1119.27 736.796 1117.63 736.621 1116.01 736.813H48C21.4901 736.813 0.000199847 715.53 0 689.277V380.29C0 354.037 21.49 332.754 48 332.754H1116.01C1117.63 332.946 1119.27 332.771 1120.82 332.241C1122.36 331.712 1123.76 330.842 1124.92 329.696C1126.08 328.558 1126.96 327.17 1127.49 325.641C1128.03 324.111 1128.2 322.479 1128.01 320.87V47.5361C1128.01 21.2832 1149.5 0.000130669 1176.01 0H2160.01ZM1193 35C1181.95 35 1173 43.9543 1173 55V1015C1173 1026.05 1181.95 1035 1193 1035H2153C2164.05 1035 2173 1026.05 2173 1015V55C2173 43.9543 2164.05 35 2153 35H1193Z"
				fill={frameBody}/>
		</g>
		<g transform={"translate(59 435) scale(1)"}>
			<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
				<defs>
					<clipPath id="myClip">
						<path d={path}/>
					</clipPath>
				</defs>
				<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
					<div
						dangerouslySetInnerHTML={{__html}}
						style={{
							width: 'calc(100%)', height: 'calc(100%)',
							display: 'flex', justifyContent: 'center', alignItems: 'center',
							...style, color: textColor
						}}
					/>
				</foreignObject>
			</svg>
		</g>
	</Svg>
}